import { AuthService }       from './auth.service';

import { Component, OnInit } from '@angular/core';
import { Router }            from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: 'auth.component.html',
    providers: [ AuthService ]
})

export class AuthComponent implements OnInit {
    constructor(
        public _auth: AuthService,
        private _router: Router
    ) { }

    ngOnInit() {
        if (this._auth.isAuthenticated()) {
            console.log('auth');
            this._router.navigate(['/dashboard']);
        } else {
            console.log('not auth');
            this._auth.login();
        }
}
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.component.ts